/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdEmployeeDataMutationRequest,
  PutApiV1PersonIdEmployeeDataMutationResponse,
  PutApiV1PersonIdEmployeeDataPathParams,
  PutApiV1PersonIdEmployeeData400,
  PutApiV1PersonIdEmployeeData401,
  PutApiV1PersonIdEmployeeData404,
  PutApiV1PersonIdEmployeeData500,
} from "../../types/personEmployeeController/PutApiV1PersonIdEmployeeData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdEmployeeData } from "../../clients/personEmployeeController/putApiV1PersonIdEmployeeData.ts";

export const putApiV1PersonIdEmployeeDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/employee-data" }] as const;

export type PutApiV1PersonIdEmployeeDataMutationKey = ReturnType<
  typeof putApiV1PersonIdEmployeeDataMutationKey
>;

export function putApiV1PersonIdEmployeeDataMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PutApiV1PersonIdEmployeeDataMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1PersonIdEmployeeDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdEmployeeDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdEmployeeData400
      | PutApiV1PersonIdEmployeeData401
      | PutApiV1PersonIdEmployeeData404
      | PutApiV1PersonIdEmployeeData500
    >,
    {
      id: PutApiV1PersonIdEmployeeDataPathParams["id"];
      data?: PutApiV1PersonIdEmployeeDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdEmployeeData(id, data, config);
    },
  });
}

/**
 * @description Atualiza a aba Employee. Cria o vínculo caso ainda não exista. Todos os campos informados sobrescrevem os atuais. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de funcionário (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/employee-data}
 */
export function usePutApiV1PersonIdEmployeeData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdEmployeeDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdEmployeeData400
        | PutApiV1PersonIdEmployeeData401
        | PutApiV1PersonIdEmployeeData404
        | PutApiV1PersonIdEmployeeData500
      >,
      {
        id: PutApiV1PersonIdEmployeeDataPathParams["id"];
        data?: PutApiV1PersonIdEmployeeDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdEmployeeDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdEmployeeDataMutationKey();

  const baseOptions = putApiV1PersonIdEmployeeDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdEmployeeDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdEmployeeData400
      | PutApiV1PersonIdEmployeeData401
      | PutApiV1PersonIdEmployeeData404
      | PutApiV1PersonIdEmployeeData500
    >,
    {
      id: PutApiV1PersonIdEmployeeDataPathParams["id"];
      data?: PutApiV1PersonIdEmployeeDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdEmployeeDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdEmployeeData400
      | PutApiV1PersonIdEmployeeData401
      | PutApiV1PersonIdEmployeeData404
      | PutApiV1PersonIdEmployeeData500
    >,
    {
      id: PutApiV1PersonIdEmployeeDataPathParams["id"];
      data?: PutApiV1PersonIdEmployeeDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdEmployeeDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdEmployeeData400
      | PutApiV1PersonIdEmployeeData401
      | PutApiV1PersonIdEmployeeData404
      | PutApiV1PersonIdEmployeeData500
    >,
    {
      id: PutApiV1PersonIdEmployeeDataPathParams["id"];
      data?: PutApiV1PersonIdEmployeeDataMutationRequest;
    },
    TContext
  >;
}
